import React, { useContext, useState } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import states from '../../lists/states.json';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import CardContact from '../../components/CardContact/CardContact';
import InputGroup from "../../components/Form/InputGroup";
import SelectGroup from "../../components/Form/SelectGroup";
import Btn from "../../components/Btn/Btn";
import Loading from '../../components/Loading/Loading';
import url from '../../apiUrl';
import axios from 'axios';
import {
    isInvaidNamePerson,
    isInvalidEmail,
    isNotTrim,
    isInvalidContentOfMask
} from '../../useFull/checkValidStrings'
import { GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import isEmpty from '../../useFull/isEmpty';
import Alert from '../../components/Alert/Alert';

const ContactUs = () => {
    const { state } = useContext(GlobalContext);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const language = state.language || 'pt-br';


    const [loadingEmail, setLodingEmail] = useState(false);
    const [cities, setCities] = useState([]);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [city, setCity] = useState('');
    const [personState, setPersonState] = useState('');
    const [celPhone, setCelPhone] = useState('');
    const [phone, setPhone] = useState('');
    const [mensage, setMensage] = useState('');
    const [acceptPolicy, setAcceptPolicy] = useState();

    const [invalidMsg, setInvalidMsg] = useState({});
    const [sessionEmail, setSessionEmail] = useState(false);
    const [alertMsg, setAlertMsg] = useState();

    const data = require(`../../assets/languages/${language}/contactUs.json`);

    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        pageSubtitle,
        cerca,
        cercaItens,
        successMsg,
        formTitle,
        formSubtitle,
        form
    } = data

    const {
        formName,
        formEmail,
        formCompany,
        formCity,
        formState,
        formCelPhone,
        formPhone,
        formMensage,
        formPolicy,
        formBtn
    } = form;

    const handlePersonState = (val) => {
        setPersonState(val.toUpperCase());
        setCity('');
        setInvalidMsg({ ...invalidMsg, [formState.name]: '' });
        const stateCode = val.split(' - ')[0].toUpperCase();
        const foundState = states.find((state) => state.value === stateCode);
        setCities([]);
        setTimeout(() => {
            setCities(foundState ? foundState.cities : []);
        }, 100);
    }

    const handleSendEmail = () => {
        const _invalidMsg = {}

        if (name.length < 5 || isInvaidNamePerson(name)) _invalidMsg[formName.name] = formName.errorMsg
        else if (isNotTrim(name)) _invalidMsg[formName.name] = formName.errorMsg2

        if (email.length < 5 || isInvalidEmail(email.toLocaleLowerCase()) || isNotTrim(email)) _invalidMsg[formEmail.name] = formEmail.errorMsg

        if (company.length < 5) _invalidMsg[formCompany.name] = formCompany.errorMsg
        else if (isNotTrim(company)) _invalidMsg[formCompany.name] = formCompany.errorMsg2

        if (city.length < 3) _invalidMsg[formCity.name] = formCity.errorMsg
        else if (city.length > 1 && isNotTrim(city)) _invalidMsg[formCity.name] = formCity.errorMsg2

        if (!celPhone || isInvalidContentOfMask(celPhone)) _invalidMsg[formCelPhone.name] = formCelPhone.errorMsg

        if (isInvalidContentOfMask(phone)) _invalidMsg[formPhone.name] = formPhone.errorMsg

        if (personState.length < 2) _invalidMsg[formState.name] = formState.errorMsg

        if (mensage.length < 20) _invalidMsg[formMensage.name] = formMensage.errorMsg

        if (isEmpty(_invalidMsg)) {
            setInvalidMsg({})
            sendEmail()
        } else {
            setInvalidMsg(_invalidMsg)
        }

    }

    const setSession = async () => {
        setLodingEmail(true)
        try {
            await axios.post(`${url}/SendNotification/iniciar-sessao`, {}, { withCredentials: true });
        } catch (error) {
            console.log(error);
        }
    };

    const sendEmail = async () => {
        if (!sessionEmail) await setSession();
        else return
        setAlertMsg(null)
        const recaptchaResponse = await executeRecaptcha('submit_form');
        const body = {
            nomeCompleto: name,
            email: email,
            celular: celPhone,
            empresa: company,
            telefone: phone,
            cidade: city,
            uf: personState,
            message: mensage,
            recaptchaResponse,
        }
        try {
            await axios.post(`${url}/SendNotification/enviar-notificacao-faleconosco`, body, { withCredentials: true });
            setSessionEmail(true)
            setLodingEmail(false)
            setAlertMsg({
                msg: successMsg,
                color: "var(--success)",
                iconName: 'success.png'
            })

        } catch (error) {
            setLodingEmail(false);
            const errors = error?.response?.data?.errors;
            let errorMsg = 'Ocorreu um erro, por favor tente novamente.';
            if (errors) {
                const errorMessages = Object.values(errors).flat();
                errorMsg = errorMessages.join(' / ');
            }
            setAlertMsg({
                msg: errorMsg,
                color: "var(--error)",
            });
        }
    }

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container mg-bot-100">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <span>{cerca}</span>
                    <div className='container-card-info'>
                        {/* Este CardContact fora do array é apenas um ajuste temporario para renderizar apenas um card */}
                        <CardContact smallLabel={cercaItens[0].smallLabel} label={cercaItens[0].label} value={cercaItens[0].value} full />
                        {/* {cercaItens.map((d, i) => <CardContact key={i} smallLabel={d.smallLabel} label={d.label} value={d.value} />)} */}
                    </div>
                    <div >
                        <PageTitle
                            title={formTitle}
                            subtitle={formSubtitle} />
                        <div className="default-form-container">
                            <form action="">
                                <div className="_form-row">
                                    <InputGroup
                                        id={formName.id}
                                        inputName={formName.name}
                                        label={formName.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formName.type}
                                        value={name}
                                        errorMsg={invalidMsg[formName.name]}
                                        _function={(val) => {
                                            setName(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formName.name]: '' })
                                        }}
                                        className="default-form-1 mg-top-30"
                                    />

                                    <InputGroup
                                        id={formEmail.id}
                                        inputName={formEmail.name}
                                        label={formEmail.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formName.type}
                                        value={email}
                                        errorMsg={invalidMsg[formEmail.name]}
                                        _function={(val) => {
                                            setEmail(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formEmail.name]: '' })
                                        }}
                                        className="default-form-1 mg-top-30"

                                    />

                                    <InputGroup
                                        id={formCompany.id}
                                        inputName={formCompany.name}
                                        label={formCompany.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formCompany.type}
                                        value={company}
                                        errorMsg={invalidMsg[formCompany.name]}
                                        _function={(val) => {
                                            setCompany(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formCompany.name]: '' })
                                        }}
                                        className="default-form-1 mg-top-30"

                                    />


                                    <SelectGroup
                                        id={formState.id}
                                        inputName={formState.name}
                                        label={formState.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formState.type}
                                        value={personState}
                                        errorMsg={invalidMsg[formState.name]}
                                        _function={handlePersonState}
                                        options={states}
                                        className="default-form-3 mg-top-30"
                                    />

                                    {cities?.length ? (
                                        <SelectGroup
                                            id={formCity.id}
                                            inputName={formCity.name}
                                            label={formCity.label}
                                            disabled={loadingEmail || sessionEmail || !cities?.length}
                                            inputType={formCity.type}
                                            value={city}
                                            errorMsg={invalidMsg[formCity.name]}
                                            _function={(val) => {
                                                setCity(val.toUpperCase());
                                                setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                            }}
                                            options={cities}
                                            className="default-form-2 mg-top-30"
                                            isUpper={true}
                                        />
                                    ) : (
                                        <InputGroup
                                            id={formCity.id}
                                            inputName={formCity.name}
                                            label={formCity.label}
                                            disabled={true}
                                            inputType={formCity.type}
                                            value={city}
                                            errorMsg={invalidMsg[formCity.name]}
                                            _function={(val) => {
                                                setCity(val.toUpperCase());
                                                setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                            }}
                                            className="default-form-2 mg-top-30"
                                        />
                                    )}


                                    {/* <InputGroup
                                        id={formCity.id}
                                        inputName={formCity.name}
                                        label={formCity.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formCity.type}
                                        value={city}
                                        errorMsg={invalidMsg[formCity.name]}
                                        _function={(val) => {
                                            setCity(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                        }}
                                        className="default-form-2 mg-top-30"
                                    /> */}

                                    <InputGroup
                                        id={formCelPhone.id}
                                        inputName={formCelPhone.name}
                                        label={formCelPhone.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formCelPhone.type}
                                        mask={formCelPhone.mask}
                                        value={celPhone}
                                        errorMsg={invalidMsg[formCelPhone.name]}
                                        _function={(val) => {
                                            setCelPhone(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formCelPhone.name]: '' })
                                        }}
                                        className="default-form-1 mg-top-30"

                                    />

                                    <InputGroup
                                        id={formPhone.id}
                                        inputName={formPhone.name}
                                        label={formPhone.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formPhone.type}
                                        mask={formPhone.mask}
                                        value={phone}
                                        errorMsg={invalidMsg[formPhone.name]}
                                        _function={(val) => {
                                            setPhone(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formPhone.name]: '' })
                                        }}
                                        className="default-form-1 mg-top-30"

                                    />

                                    <InputGroup
                                        id={formMensage.id}
                                        inputName={formMensage.name}
                                        label={formMensage.label}
                                        disabled={loadingEmail || sessionEmail}
                                        inputType={formMensage.type}
                                        value={mensage}
                                        errorMsg={invalidMsg[formMensage.name]}
                                        _function={(val) => {
                                            setMensage(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formMensage.name]: '' })
                                        }}
                                        isTextArea={true}
                                        placeholder={'Escreva brevemente sua solicitação'}
                                        className="w-100 mg-bot-50 mg-top-30"
                                    />
                                    <GoogleReCaptcha />
                                </div>
                            </form>
                        </div>
                        <div>
                            <div className="container-privacy-term">
                                <div className="content-privacy-term">
                                    <input
                                        type="checkbox"
                                        id={formPolicy.id}
                                        name={formPolicy.name}
                                        className='_checkbox'
                                        checked={acceptPolicy}
                                        disabled={loadingEmail || sessionEmail}
                                        onChange={() => setAcceptPolicy(!acceptPolicy)}
                                    />
                                    <label htmlFor={formPolicy.id} dangerouslySetInnerHTML={{ __html: formPolicy.label }} className="mg-l-10">
                                    </label>
                                </div>
                                {loadingEmail ? (
                                    <div className='default-policy-container-loading'>
                                        <Loading />
                                    </div>

                                ) : (
                                    <Btn
                                        label={formBtn.label}
                                        disabled={!name || !email || !company || !city || !personState || !celPhone || !mensage || !acceptPolicy || sessionEmail}
                                        className='default-form-btn'
                                        _function={handleSendEmail}
                                    />
                                )}
                            </div>
                        </div>
                        {alertMsg && (
                            <Alert msg={alertMsg.msg} color={alertMsg.color} ignorable={true} _requestClose={() => setAlertMsg(null)} iconName={alertMsg.iconName} />
                        )}
                    </div>
                </section>
            </div>
        </>
    )
}

export default ContactUs
